import axios from '@lib/apiClient'

export function getSurveyExperience(token) {
  return axios.get(`/api/recipients/${token}/survey_experience.json`)
}

export function patchRecipient(recipient) {
  return axios.patch(`/api/recipients/1.json`, { recipient: recipient })
}

export function getRecipientRoles() {
  return axios.get(`/api/recipient_roles.json`).then((response) => response.data.recipient_roles)
}

export function getSurveyPreview(token) {
  return axios.get(`/api/surveys/${token}/preview.json`)
}

export function signInAndGetRecipient(token) {
  return axios.patch(`/api/recipients/sign_in_recipient.json`, {
    recipient_token: token,
  })
}

export function patchRecipientDone(token) {
  return axios.patch(`/api/recipients/${token}/mark_complete.json`)
}

export function getRecipientByToken(token) {
  return axios.get(`/api/recipients/${token}/find_by_token.json`)
}
